import tree from "../../../components/tree.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import {
    domainName
} from "../../../utility/index"
import {
    downLoadTemplateFile,
    exportTerminalFile
} from '../../../api/config/modules/TerminalFile'
import moment from "moment";
export default {
    name: "TerminalFile",
    components: {
        tree,
        iTable,
        IPagination
    },
    data() {
        return {
            isCollapse: false,
            formInline: {
                terminalId: '',
                typeId: '',
                simIccicd: '',
                factoryDate: [],
                firmwareVersion: '',
                isFirmwareVersion: ''
            },
            optionsInput: [{
                value: '',
                label: this.$t('common.all')
            }, {
                value: '0',
                label: this.$t('common.equal')
            }, {
                value: '1',
                label: this.$t('common.unequal')
            }],
            BrandList: [{
                id: '',
                name: this.$t('common.all')
            }],
            typeList: [{
                id: '',
                name: this.$t('common.all')
            }],
            // typeList: [],
            // pastList: [
            //     {
            //         value: '',
            //         label: this.$t('common.all')
            //     }, {
            //         value: '0',
            //         label: this.$t('common.equal')
            //     }, {
            //         value: '1',
            //         label: this.$t('common.unequal')
            //     }
            // ],
            height: '550',
            list: [],
            option: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false,
                mutiSelect: true,
                serialNumber: true,
            },
            columns: [{
                prop: "terminalId",
                label: this.$t('TerminalFile.terminalId'),
                align: "center",
                width: "260px",
            },
            {
                prop: "typeName",
                label: this.$t('TerminalFile.typeId'),
                align: "center",
                width: "200px"
            },
            {
                prop: "terminalState",
                label: this.$t('SIMFile.assetStatus'),
                align: "center",
                width: "200px",
                render: (h, params) => {
                    return h('el-tag', {
                        props: { type: params.row.terminalState === null ? '' : params.row.terminalState === 0 ? 'success' : 'danger' }
                    }, params.row.terminalState === null ? '' : params.row.terminalState === 0 ? this.$t('SIMFile.inUse') : this.$t('SIMFile.abandoned'))
                }
            },
            {
                prop: "firmwareVersion",
                label: this.$t('TerminalFile.firmwareVersion'),
                align: "center",
                width: "260px"
            },
            {
                prop: "deliveryTime",
                label: this.$t('TerminalFile.deliveryTime'),
                align: "center",
                width: "200px"
            },
            {
                prop: "simIccicd",
                label: this.$t('TerminalFile.simIccicd'),
                align: "center",
                width: "260px",
            },
            {
                prop: "expirationDate",
                label: this.$t('TerminalFile.expirationDate'),
                align: "center",
                width: "200px",
            },
            {
                prop: "expirationState",
                label: this.$t('TerminalFile.expirationState'),
                align: "center",
                width: "200px",
                render: (h, params) => {
                    return h('el-tag', {
                        props: { type: params.row.expirationState === null ? '' : params.row.expirationState === 0 ? 'success' : 'danger' }
                    }, params.row.expirationState === null ? '' : params.row.expirationState === 0 ? this.$t('common.search.inWarranty') : this.$t('common.search.outWarranty'))
                }
            },
            // {
            //     prop: "expirationDate",
            //     label: this.$t('SIMFile.expirationDate'),
            //     align: "center",
            //     width: "200px",
            // },
            // {
            //     prop: "expirationState",
            //     label: this.$t('TerminalFile.pastDue'),
            //     align: "center",
            //     width: "200px",
            //     render: (h, params) => {
            //         return h('el-tag', {
            //             props: { type: params.row.expirationState === null ? '' : params.row.expirationState === 0 ? 'success' : 'danger' }
            //         }, params.row.expirationState === null ? '' : params.row.expirationState === 0 ? this.$t('common.search.inWarranty') : this.$t('common.search.outWarranty'))
            //     }
            // },
            ],
            operates: {
                width: 100,
                fixed: "right",
                list: [
                ],
            },
            currentPage: 1,
            pageSize: 10,
            total: 1,
            dialogFormVisible: false,
            formLabelWidth: '100px',
            diaTitle: '',
            btnType: '',
            rules: {
                terminalId: [{
                    required: true,
                    message: this.$t('TerminalFile.form.terminalId'),
                    trigger: 'blur'
                }],
                typeId: [{
                    required: true,
                    message: this.$t('TerminalFile.form.typeId'),
                    trigger: 'change'
                }],
                deliveryTime: [{
                    required: true,
                    message: this.$t('TerminalFile.form.deliveryTime'),
                    trigger: 'change'
                }],
            },
            form: {
                terminalId: '',
                typeId: '',
                pushState: '',
                simIccicd: '',
                deliveryTime: '',
            },
            disabled: false,
            selected: [],
            abandonedDisabled: true,
            id: '',
            name: '',
            dialogBatchFormVisible: false,
            dialogAbandonedFormVisible: false,
            abandonedForm: {
                terminalId: '',
                isAbandonSim: true,
                remarks: '',
            },
        }
    },
    created() {
        this.getTerminalType()
        this.getAllTerminal()
    },
    methods: {
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        getAllTerminal() {
            let startTime = ''
            let endTime = ''
            if (this.formInline.factoryDate) {
                if (this.formInline.factoryDate.length > 0) {
                    startTime = this.formInline.factoryDate[0]
                    endTime = this.formInline.factoryDate[1]
                }
            }
            let param = {
                companyId: sessionStorage.getItem("companyId"),
                terminalId: this.formInline.terminalId,
                typeId: this.formInline.typeId,
                firmwareVersion: this.formInline.firmwareVersion,
                isFirmwareVersion: this.formInline.isFirmwareVersion,
                simIccicd: this.formInline.simIccicd,
                startTime: startTime,
                endTime: endTime,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
            }
            this.$store.dispatch('TerminalFile/GET_SELECTALLTERMINAL', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.$refs.page.CommandCurrentPage = 1
            this.currentPage = 1
            this.getAllTerminal()
        },
        onClear() {
            this.formInline = {
                terminalId: '',
                typeId: '',
                simIccicd: '',
                factoryDate: [],
            }
            this.getAllTerminal()
        },
        refreshTerminal() {
            this.$store.dispatch('TerminalFile/GET_REFRESHTERMINAL', {}).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.$message.success(this.$t('common.btn.refreshSuccess'))
                    }
                }
            }).catch(err => { })
        },
        getTerminalType() {
            this.$store.dispatch('TerminalCommand/GET_TERMINALTYPE', {}).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.typeList = res.data.data
                    }
                }
            }).catch(err => { })
        },
        addTerminal() {
            this.dialogFormVisible = true
            this.diaTitle = this.$t('common.btn.add')
            this.btnType = 'add'
            this.disabled = false
            this.form.deliveryTime = moment().format("YYYY-MM-DD")
            this.form.terminalId = ''
            this.form.typeId = ''
            this.form.pushState = ''
            this.form.simIccicd = ''
            this.$nextTick(() => {
                this.$refs.form.resetFields()
            })
        },
        editTerminal() {
            this.dialogFormVisible = true
            this.diaTitle = this.$t('common.btn.edit')
            this.btnType = 'edit'
            this.disabled = true
            this.$nextTick(() => {
                this.$refs.form.clearValidate()
            })
            this.form.terminalId = this.selected[0].terminalId
            this.form.typeId = this.selected[0].typeId
            this.form.pushState = String(this.selected[0].pushState)
            this.form.simIccicd = this.selected[0].simIccicd
            this.form.deliveryTime = this.selected[0].deliveryTime
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let param = {
                        companyId: sessionStorage.getItem("companyId"),
                        terminalId: this.form.terminalId,
                        typeId: this.form.typeId,
                        pushState: this.form.pushState,
                        simIccicd: this.form.simIccicd,
                        deliveryTime: this.form.deliveryTime,
                    }
                    if (this.btnType == 'add') {
                        this.$store.dispatch('TerminalFile/GET_INSERTTERMINAL', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('common.btn.addSuccess'))
                                this.dialogFormVisible = false;
                                this.getAllTerminal();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })
                    } else {
                        this.$store.dispatch('TerminalFile/GET_UPDATETERMINAL', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('common.btn.editSuccess'))
                                this.dialogFormVisible = false;
                                this.getAllTerminal();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })
                    }


                } else {
                    return false;
                }
            });
        },
        cancle(formName) {
            this.dialogFormVisible = false;
            this.form = {
                terminalId: '',
                typeId: '',
                pushState: '',
                simIccicd: '',
                deliveryTime: '',
            }
        },
        closeDia() {
            this.form = {
                terminalId: '',
                typeId: '',
                pushState: '',
                simIccicd: '',
                deliveryTime: '',
            }
            this.dialogFormVisible = false;
        },

        abandonedTerminal() {
            this.dialogAbandonedFormVisible = true
            this.abandonedForm.isAbandonSim = true
            this.abandonedForm.remarks = ''
        },
        submitAbandonedForm(abandonedFormName) {
            this.$refs[abandonedFormName].validate((valid) => {
                if (valid) {
                    let param = {
                        terminalId: this.selected[0].terminalId,
                        isAbandonSim: Number(this.abandonedForm.isAbandonSim),
                        remarks: this.abandonedForm.remarks,
                    }
                    this.$store.dispatch('TerminalFile/GET_ABANDONEDTERMINAL', param).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success(this.$t('SIMFile.abandonedSuccessfully'))
                            this.dialogFormVisible = false;
                            this.getAllTerminal();
                            this.closeAbandonedDia();
                        } else {
                            this.$message.error(res.data.msg)
                        }

                    }).catch(err => { })

                } else {
                    return false;
                }
            });
        },
        abandonedCancle(abandonedFormName) {
            this.abandonedForm = {
                terminalId: '',
                isAbandonSim: true,
                remarks: '',
            }
            this.dialogAbandonedFormVisible = false;
        },
        closeAbandonedDia() {
            this.abandonedForm = {
                terminalId: '',
                isAbandonSim: true,
                remarks: '',
            }
            this.dialogAbandonedFormVisible = false;
        },

        deleteTerminal() {
            this.$confirm(this.$t('common.btn.confirmDelete'), this.$t('common.btn.hint'), {
                cancelButtonText: this.$t('common.btn.cancel'),
                confirmButtonText: this.$t('common.btn.confirm'),
                type: 'warning'
            }).then(res => {
                let param = {
                    terminalIds: this.selected.map(item => item.terminalId).join()
                }
                this.$store.dispatch('TerminalFile/GET_DELETETERMINAL', param).then(response => {
                    if (response.data.code == 200) {
                        this.getAllTerminal()
                        this.$message.success(this.$t('common.btn.deleteSuccess'))
                    } else {
                        this.$message.error(response.data.msg)
                    }
                }).catch(error => { })
            }).catch(err => {

            })
        },

        BulkImport() {
            this.dialogBatchFormVisible = true
        },

        TemplateFile() {
            if (domainName) {

                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/getExportExcel/exportTerminalModel`
                    location.href = url

                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/exportTerminalModel`
                    location.href = url

                }
            }
        },

        uploadFile(e) {
            let dom = document.getElementById('uploadDom')
            let file = dom.files[0];
            let companyId = sessionStorage.getItem('companyId')
            let userId = sessionStorage.getItem('userId')
            let formData = new FormData()
            formData.append('File', file)
            formData.append('userId', userId)
            formData.append('companyId', companyId)
            let types = file.name.split('.')[1]
            if (types != "xlsx" && types != "xls") {
                this.$message.error(this.$t('TerminalFile.form.choseExcel'));
                return false;
            } else {
                this.$store.dispatch('TerminalFile/GET_UPLOADTERMINAL', formData).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(this.$t('common.btn.fileUploadSuccess'))
                        this.dialogBatchFormVisible = false;
                        this.getAllTerminal()
                    } else {
                        this.$message.error(res.data.msg)
                    }
                    document.getElementById('uploadDom').value = ''
                }).catch(err => {
                    this.$message.error(this.$t('common.btn.fileUploadError'))
                    document.getElementById('uploadDom').value = ''
                })
            }
        },
        closeBatchDia() {
            this.dialogBatchFormVisible = false
        },
        downTerminal() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let startTime = ''
                    let endTime = ''
                    if (this.formInline.factoryDate) {
                        if (this.formInline.factoryDate.length > 0) {
                            startTime = this.formInline.factoryDate[0]
                            endTime = this.formInline.factoryDate[1]
                        }
                    }
                    let companyId = sessionStorage.getItem("companyId")
                    let url = `https://${domainName}/v1/getExportExcel/exportTerminal?companyId=${companyId}&firmwareVersion=${this.formInline.firmwareVersion}&isFirmwareVersion=${this.formInline.isFirmwareVersion}&terminalId=${this.formInline.terminalId}&typeId=${this.formInline.typeId}&simIccicd=${this.formInline.simIccicd}&startTime=${startTime}&endTime=${endTime}`
                    location.href = url

                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/exportTerminal?companyId=${companyId}&firmwareVersion=${this.formInline.firmwareVersion}&isFirmwareVersion=${this.formInline.isFirmwareVersion}&terminalId=${this.formInline.terminalId}&typeId=${this.formInline.typeId}&simIccicd=${this.formInline.simIccicd}&startTime=${startTime}&endTime=${endTime}`
                    location.href = url
                }
            }
        },
        handleSelectionChange(val) {
            this.selected = val
            if (this.selected.length > 0) {
                if (this.selected[0].terminalState === 1) {
                    this.abandonedDisabled = true
                } else {
                    this.abandonedDisabled = false
                }
            } else {
                this.abandonedDisabled = true
            }
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getAllTerminal();
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}